import { render } from "./trivia.vue?vue&type=template&id=11daf9ec&scoped=true"
import script from "./trivia.vue?vue&type=script&lang=js"
export * from "./trivia.vue?vue&type=script&lang=js"

import "./trivia.vue?vue&type=style&index=0&id=11daf9ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11daf9ec"]])

export default __exports__